import React, {useEffect, useState} from "react";
import {nonObject} from "../../../../components/commonmethod/CommonMethod";

function CompanyManageSearchBar({saveConditions, handleSearch}) {
    const [searchTxt, setSearchTxt] = useState(saveConditions?.searchTxt ?? "");

    useEffect(() => {
        setSearchTxt(saveConditions?.searchTxt ?? "");
    }, [saveConditions?.searchTxt]);

    const submitSearch = () => {
        nonObject(saveConditions, searchTxt, handleSearch, "searchTxt");
    };

    return (
        <div className="company-manage-search">
            <div className="company-manage-search__input-slot">
                <input
                    type="text"
                    className="company-manage-search__input basic-input input-style"
                    placeholder="회사명, 사무실번호, 주소"
                    value={searchTxt}
                    onChange={(e) => setSearchTxt(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            submitSearch();
                        }
                    }}
                />
            </div>
        </div>
    );
}

export default CompanyManageSearchBar;
